import React from "react";
import { Stack } from "@mui/material";
import ProductDataToggle from "./ProductDataToggle";
import { DATA_TOGGLE_TYPES } from "./ProductDataToggle";
import { useUserStateContext } from "App";

function DataToggles({ onProductPage = false }) {
  const { userCreds } = useUserStateContext();
  const stylingSpecs = onProductPage
    ? "mr-[25px] mt-[10px] items-start gap-[16px] mb-[24px]"
    : "gap-[16px] items-start";
  return (
    <Stack
      direction="column"
      className={stylingSpecs}
    >
      <ProductDataToggle
        dataToggleType={DATA_TOGGLE_TYPES.HIDE_PRICES}
        userId={userCreds?.cognitoID}
        onProductPage={onProductPage}
      />
      <ProductDataToggle
        dataToggleType={DATA_TOGGLE_TYPES.SHOW_ONLY_SYNCED_VENDORS}
        userId={userCreds?.cognitoID}
        onProductPage={onProductPage}
      />
    </Stack>
  );
}

export default DataToggles;
